module.exports = __webpack_public_path__ + "img/origins_header.a2ebb398.png";